import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { colors } from '../constants';

export default function LoadingState({ height = 240 }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: height,
      }}
    >
      <CircularProgress sx={{ color: colors.primary }} />
    </Box>
  );
}
